import React from 'react'

import { formatAddress, capitalizeString } from '../../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import { InfoIcon } from '../../InfoIcon'
import { RequiredText } from '../../RequiredText'

export default function BasicInfo({
  isEditable,
  isEventPublished,
  handleChange,
  handleVenue,
  handleCategory,
  handleSubCategory,
  event,
  venues,
  categories,
  requiredFieldErrorStatus,
}) {
  const selectedCategoryId = event?.category?.id || event?.category || ''
  const selectedCategory = categories?.find(
    (cat) => String(cat?.id) === String(selectedCategoryId)
  )
  const availableSubCategories = selectedCategory?.subCategories || []
  const selectedSubCategoryIds = (event?.sub_categories || []).map(
    (sub) => sub?.id || sub
  )

  return (
    <>
      <Form.Group className="form-group" controlId="venue">
        <div className="form-label--flex">
          <Form.Label>Venue</Form.Label>
          {requiredFieldErrorStatus?.venue && <RequiredText />}
        </div>
        <Form.Select
          name="venue"
          disabled={isEditable || isEventPublished}
          value={event.room?.uuid}
          onChange={handleVenue}
          className={requiredFieldErrorStatus?.venue ? 'error-border' : ''}
          autoFocus
        >
          <option disabled hidden value="">
            Select venue
          </option>
          {venues &&
            venues.map((option, index) => (
              <optgroup
                label={`${option?.name} - ${formatAddress(option)}`}
                key={index}
              >
                {option.rooms?.map((room, i) => (
                  <option value={room.uuid} data-venue={option} key={i}>
                    {capitalizeString(room.name)}
                  </option>
                ))}
              </optgroup>
            ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="form-group" controlId="name">
        <div className="form-label--flex">
          <Form.Label>Event Name</Form.Label>
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>
                Maximum 100 characters. No HTML or emoji allowed
              </Tooltip>
            }
          >
            <Button variant="link">
              <InfoIcon />
            </Button>
          </OverlayTrigger>
          {requiredFieldErrorStatus?.name && <RequiredText />}
        </div>
        <Form.Control
          type="text"
          name="name"
          placeholder="Enter event name"
          disabled={isEditable}
          maxLength="100"
          value={event ? event?.name : ''}
          onChange={handleChange}
          required
          className={requiredFieldErrorStatus?.name ? 'error-border' : ''}
        />
      </Form.Group>
      <Form.Group className="form-group" controlId="category">
        <Form.Label>Category</Form.Label>
        <Form.Select
          name="category"
          disabled={isEditable}
          value={selectedCategoryId}
          onChange={handleCategory}
          className="text-capitalize"
        >
          <option value="">Select category</option>
          {categories?.map((cat, i) => (
            <option className="text-capitalize" key={i} value={cat?.id}>
              {cat?.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {availableSubCategories.length > 0 && (
        <Form.Group className="form-group" controlId="sub_categories">
          <Form.Label>Subcategories</Form.Label>
          <Stack gap={2}>
            {availableSubCategories.map((sub) => {
              const subId = sub?.id
              const checked = selectedSubCategoryIds.some(
                (id) => String(id) === String(subId)
              )
              return (
                <Form.Check
                  key={subId}
                  type="checkbox"
                  id={`sub-category-${subId}`}
                  label={sub?.name}
                  value={subId}
                  checked={checked}
                  disabled={isEditable}
                  onChange={handleSubCategory}
                  className="text-capitalize"
                />
              )
            })}
          </Stack>
        </Form.Group>
      )}
    </>
  )
}
